import type {
    IDocumentExtractedFieldsResponse,
    IExtractedCOIResponse,
} from "@/api/documents";
import { isEmptyPropertyValue } from "@/utils/fields";

export const COI_NULLABLE_FIELDS = [
    "certificate_date",
    "revision_number",
    "authorized_representative",
    "producer_name",
    "producer_address",
    "producer_contact_name",
    "producer_phone",
    "producer_fax",
    "producer_email",
    "insured_name",
    "insured_address",
    "certificate_holder_name",
    "certificate_holder_address",
    "insurer_a_name",
    "insurer_a_naic",
    "insurer_b_name",
    "insurer_b_naic",
    "insurer_c_name",
    "insurer_c_naic",
    "insurer_d_name",
    "insurer_d_naic",
    "insurer_e_name",
    "insurer_e_naic",
    "insurer_f_name",
    "insurer_f_naic",
    "description_of_operations",
] as const satisfies readonly (keyof IExtractedCOIResponse)[];

export function countHiddenFields(
    data: IDocumentExtractedFieldsResponse | undefined | null,
    coi?: IExtractedCOIResponse | null
): number {
    let count = 0;
    if (data?.field_groups) {
        for (const group of data.field_groups) {
            for (const field of group.scalar_fields ?? []) {
                for (const item of field.items ?? []) {
                    for (const prop of item.properties ?? []) {
                        if (isEmptyPropertyValue(prop.value)) count++;
                    }
                }
            }
            for (const field of group.array_fields ?? []) {
                for (const item of field.items ?? []) {
                    for (const prop of item.properties ?? []) {
                        if (isEmptyPropertyValue(prop.value)) count++;
                    }
                }
            }
            for (const cf of group.custom_fields ?? []) {
                for (const prop of cf.properties ?? []) {
                    if (isEmptyPropertyValue(prop.value)) count++;
                }
            }
        }
    }
    if (coi) {
        for (const key of COI_NULLABLE_FIELDS) {
            if (isEmptyPropertyValue(coi[key])) count++;
        }
    }
    return count;
}
